import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    bookings: [],
};

export const bookingsSlice = createSlice({
    name: 'bookingsSlice',
    initialState,
    reducers: {
        
        getAllBookings: (state, action) => {
            state.bookings = action.payload;
        },
        
    },
});

// Action creators are generated for each case reducer function
export const { getAllBookings} = bookingsSlice.actions;

export default bookingsSlice.reducer;
